require('../../modules/es6.object.keys');
module.exports = require('../../modules/$.core').Object.keys;


//////////////////
// WEBPACK FOOTER
// ./~/react-attrs-filter/~/core-js/library/fn/object/keys.js
// module id = 1590
// module chunks = 0